
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M17.812 23C10 23 10 15 10 15H7l4.979-4L17 15h-3s-.812 6.094 3.812 8zm1.667-14.908C19.267 4.141 16.006 1 12 1S4.733 4.141 4.521 8.092A5.499 5.499 0 005.5 19h3.302a12.304 12.304 0 01-.578-2H5.5C3.57 17 2 15.43 2 13.5c0-2.797 2.479-3.833 4.433-3.72C6.266 5.562 8.641 3 12 3c3.453 0 5.891 2.797 5.567 6.78C19.312 9.734 22 10.531 22 13.5c0 1.93-1.57 3.5-3.5 3.5h-2.518c.062.62.21 1.329.499 2H18.5a5.499 5.499 0 00.979-10.908z"}})])
          )
        }
      }
    